export default function errorMessage(state = [], action) {    
    switch (action.type) {
        case 'ADD_ERRO_MENSAGEM':
            return action.error;
        default:
            return state;
    }
}